export const MODULE_IDS = [
  'today',
  'todo',
  'calendar',
  'spending',
  'budget',
  'shopping',
  'payments',
  'habits',
  'quit_smoking',
  'weight',
  'journal',
  'export',
] as const;

export type ModuleId = (typeof MODULE_IDS)[number];

export interface ModuleMeta {
  id: ModuleId;
  name: string;
  /** Cannot be turned off by the user (Today, To-do). */
  alwaysOn?: boolean;
  /** Unticked by default in exports and hideable from Today. */
  privateByDefault?: boolean;
  /** The release that first ships this module, e.g. '0.1.0'. */
  since: string;
}

export const MODULES: Record<ModuleId, ModuleMeta> = {
  today: { id: 'today', name: 'Today', alwaysOn: true, since: '0.1.0' },
  todo: { id: 'todo', name: 'To-do', alwaysOn: true, since: '0.7.0' },
  calendar: { id: 'calendar', name: 'Calendar', since: '0.8.0' },
  spending: { id: 'spending', name: 'Spending', since: '0.1.0' },
  budget: { id: 'budget', name: 'Budget', since: '0.2.0' },
  shopping: { id: 'shopping', name: 'Shopping list', since: '0.2.0' },
  payments: { id: 'payments', name: 'Payments', since: '0.4.0' },
  habits: { id: 'habits', name: 'Habits', since: '0.7.0' },
  quit_smoking: {
    id: 'quit_smoking',
    name: 'Quit Smoking',
    privateByDefault: true,
    since: '0.3.0',
  },
  weight: { id: 'weight', name: 'Weight', privateByDefault: true, since: '0.7.0' },
  journal: { id: 'journal', name: 'Journal', privateByDefault: true, since: '0.8.0' },
  export: { id: 'export', name: 'Export', since: '0.6.0' },
};

export function isModuleId(value: unknown): value is ModuleId {
  return typeof value === 'string' && (MODULE_IDS as readonly string[]).includes(value);
}
